module.exports = __webpack_public_path__ + "img/media (9).f37ed798.png";